import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MD_DIALOG_DATA, MdDialog } from '@angular/material';
import { ExistingRule } from '../../models/existing-rule';
import { Rule } from '../../models/rule';
import { MagicBoxService } from '../../services/magic-box.service';
import { RulesService } from '../../services/rules.service';
import { RulesActions } from '../../store/actions/rules.actions';
import { DeleteGeneratedFieldsComponent } from '../delete-generated-fields/delete-generated-fields.component';
import { SuccessComponent } from '../success/success.component';

@Component({
  selector: 'app-rule-duplicate-warning',
  templateUrl: './rule-duplicate-warning.component.html',
  styleUrls: ['./rule-duplicate-warning.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RuleDuplicateWarningComponent {

  message: string;
  values: ExistingRule[];
  rule: Rule;
  loading = false;
  mode: string;

  /**
   * Initialize variables with the modal config
   * @param data
   * @param {Router} router
   */
  constructor(@Inject(MD_DIALOG_DATA) public data: any,
    private magicBoxService: MagicBoxService,
    private rulesActions: RulesActions,
    private rulesService: RulesService,
    private mdDialog: MdDialog) {
    this.message = data.message;
    this.values = data.values.map(value => new ExistingRule(value));
    this.rule = data.rule;
    this.mode = data.mode;
  }

  update() {
    this.loading = true;

    this.values.filter(r => r.selected && r.ruleId > 0).map(rule => {
      this.rule.linkedRules.push(rule.ruleId);
    });

    this.rule.languages = [];
    this.values.filter(r => r.selected && r.ruleId === 0).map(rule => {
      this.rule.languages.push(rule.language.id);
    });

    const message = (this.rule.linkedRules.length > 1) ? 'Rules has been updated/created' : 'Rule has been updated';

    this.magicBoxService.updateAll(this.rule).subscribe(res => {
      if (res.success) {
        this.loading = false;
        this.rulesService.rulesUpdated.emit(true);
        this.mdDialog.closeAll();
        this.mdDialog.open(SuccessComponent, { data: { message } });
      }
    });
  }

  delete() {
    this.loading = true;

    this.values.filter(r => r.selected).map(rule => {
      this.rule.linkedRules.push(rule.ruleId);
    });


    this.magicBoxService.deleteAll(this.rule).subscribe(res => {
      if (res.success) {
        this.loading = false;
        this.rulesActions.deleteRule(this.rule);
        this.rulesService.rulesUpdated.emit(true);
        this.mdDialog.closeAll();

        // Open new dialog, asking if user want deletion of titles generated by specific MagicBox Rules
        this.mdDialog.open(DeleteGeneratedFieldsComponent, { data: res.values });
      }
    });
  }

  isSelected() {
    return this.values.filter(r => r.selected).length === 0;
  }

  allAreSelected() {
    return this.values.filter(rule => rule.selected).length === this.values.length;
  }

  selectAll() {
    const allAreSelected = this.allAreSelected();
    this.values.map(rule => {
      rule.selected = !allAreSelected;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/rule-duplicate-warning/rule-duplicate-warning.component.ts